import { MenuItems } from './menu-items';

// Bot menu: Used for multi-bot tenants when navigating to /bots/:id/* URLs
// Includes "Back" button and developer/admin features
export const botMenu = [
  MenuItems.Back,
  MenuItems.BotAdmin,
  MenuItems.BotGeneral,
  MenuItems.BotDashboard,
  MenuItems.ChatQueue,
  MenuItems.BotChannels,
  MenuItems.BotDialogs,
  MenuItems.BotDialogs2,
  MenuItems.BotCommands,
  MenuItems.BotPlaybooks,
  MenuItems.BotActions,
  MenuItems.BotConnectors,
  MenuItems.BotAudience,
  MenuItems.BotDialogOverrides,
  MenuItems.BotForms,
  MenuItems.BotOrganization,
  MenuItems.BotQueries,
  MenuItems.BotReports,
  MenuItems.BotEvents,
  MenuItems.BotConversations,
  MenuItems.BotDialogMessages,
  MenuItems.BotRoles,
  MenuItems.BotTags,
  MenuItems.BotTriggers,
  MenuItems.BotSettings,
  MenuItems.BotWatchers,
  MenuItems.Help
];
